import { render } from "./TrashedPosts.vue?vue&type=template&id=c45abf86&ts=true"
import script from "./TrashedPosts.vue?vue&type=script&lang=ts"
export * from "./TrashedPosts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
